export const isValidName = (value: string) => {
  const normalizedValue = value.trim()

  return normalizedValue.length >= 2 && /^[a-zA-Z0-9а-яА-Я .-]+$/.test(normalizedValue)
}
